// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"IconFb_wrapper__1ACG9","wrapper__p":"IconFb_wrapper__p__2NwCA"};